module.exports = __webpack_public_path__ + "static/img/ROME_OAK.479173d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/ROME_OAK.jpg
// module id = /vLh
// module chunks = 0